import { EventSwatch } from "./EventSwatch";
import { formatDate } from "./helpers";
import { type AnnualWheelEvent } from "./types";

export const EventSummary = ({
  annualWheelEvent,
}: {
  annualWheelEvent: AnnualWheelEvent;
}) => (
  <div className="flex flex-col gap-1">
    <div className="text-muted-foreground">
      {formatDate(annualWheelEvent.date)}
    </div>
    <div className="flex items-center gap-2 text-sm font-semibold">
      <EventSwatch color={annualWheelEvent.color} />
      {annualWheelEvent.name}
    </div>
  </div>
);
